import {
  OMSMetricsRequestSchema,
  TotalAdjustmentByCarrierResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getTotalAdjustmentByCarrier = {
  name: "getTotalAdjustmentByCarrier" as const,
  input: OMSMetricsRequestSchema,
  output: TotalAdjustmentByCarrierResponseSchema,
};
